module.exports = "<p>\n  new-temp-report works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/device-report/tempreture-report/new-temp-report/new-temp-report.component.html
// module id = ../../../../../src/app/device-report/tempreture-report/new-temp-report/new-temp-report.component.html
// module chunks = main